<template>
    <div class="row mt-5">
        <div class="col-12 div-plans">
            <legend>{{ translate.PlansSubTitle }}</legend>
            <div class="list-plans px-3 mt-5">
                <div class="row mt-3" v-for="item in plans" :key="item.id">
                    <div class="col-2 d-w">
                        <input class="form-check-input" type="radio" name="flexRadioPlans" :id="'flexRadioPlans' + item.id">
                    </div>
                    <div class="col-4">
                        <div class="row d-flex">
                            <div v-if="item.discount > 0" class="col-lg-6 col-12 discont-w">
                                <span class="discont">{{ item.discount }}% OFF</span>
                            </div>
                            <div v-else class="col-lg-6 col-12"></div>
                            <div class="col-lg-6 col-12 d-w">
                                <span class="plan-name"> {{ item.period }} </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="row d-flex">
                            <div class="col-lg-6 col-12 d-w">
                                <span class="value">{{locale === 'pt-br'? 'R$' : '$'}} {{ item.value }}</span>
                            </div>
                            <div class="col-lg-6 col-12 d-w-2">
                                <span class="value-day">({{ translate.PlanValueDay }} {{ translate.current
                                }}{{ decimalParaCentavos(item.in_cents) }}/{{ translate.day }})</span>
                            </div>
                        </div>
                    </div>
                    <hr class="hr m-3 hr-blurry" />
                </div>
                <span id="warn">{{ translate.legendaAssinePagamentosSubTitle }}</span>
            </div>
        </div>
    </div>
</template>
  
<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { localeStore } from 'stores/locale'
import tradutor from 'tradutors/assine'
import router from "router"
export default defineComponent({
    name: 'SubscribePlans',
    props: ['plans'],
    computed: {
        ...mapState(localeStore, ['locale']),
        translate: function () {
            if (this.locale === 'pt-br') {
                return tradutor.portugues
            } else {
                return tradutor.ingles
            }
        }
    },
    mounted() {
        this.selectRadiosDefault()
    },
    methods: {
        decimalParaCentavos: function (numeroDecimal) {
            // Divide o número decimal por 100 para obter o valor em centavos
            var valorCentavos = Number(numeroDecimal) / 100

            // Formata o valor com duas casas decimais
            var valorFormatado = valorCentavos.toFixed(2)

            // Retorna o valor formatado como uma string
            return valorFormatado.replace('.', ',')
        },
        redirect(name) {
            router.push({
                name,
                params: {
                    locale: this.locale
                }
            })
        },
        selectRadiosDefault() {
            document.getElementsByName('flexRadioPlans')[2].checked = true
        }
    }
})
</script>
  
<style scoped lang="css">
.form-check-input:checked[type=radio] {
    --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23000'/%3e%3c/svg%3e");
}

.form-check-input:checked {
    background-color: #ffffff;
    border-color: #000;
}

.form-check-input {
    --bs-form-check-bg: #fff;
    width: 2em;
    height: 2em;
    margin-top: 0;
}

legend {
    font-family: 'Roboto-Medium';
    line-height: 28px;
    font-size: 24px;
    color: #b40909;
    margin-bottom: 50px;
    margin-left: 10px;
}

.black-title {
    color: #000;
    font-weight: bold;
    font-size: 26px;
    font-family: 'Exo-2';
    font-style: italic;
}

.subtitle span {
    font-size: 16px;
    font-weight: bold;
}

.discont-w {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #6ca727;
    padding: 5px;
    border-radius: 20px;
    text-align: center;
    height: 33px;
}

.discont {
    color: #fff;
    font-family: 'Roboto-Bold';
    line-height: 19px;
    size: 16px;
}

.plan-name {
    color: #000;
    text-align: center;
    font-family: 'Roboto-Medium';
    font-size: 18px;
    line-height: 21px;
}

.d-w {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: top;
}

.d-w-2 {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.value {
    color: #b20000;
    text-align: center;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    line-height: 28px;
}

.value-day {
    text-align: center;
    font-family: 'Roboto-Regular';
    font-size: 11px;
    line-height: 13px;
}

.d-w-btn button {
    color: #fff;
    padding: 5px;
}

.d-w-btn {
    background: #000;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

#warn{
    font-size: 13px;
    font-family: 'Roboto-Regular';
    line-height: 15px;
    font-style: italic;
    color: #999;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
    .div-plans {
        width: 100%;
        margin-left: 0px;
    }
    legend {
        font-size: 18px;
    }    

}
</style>
  